import { apiIsomorphicFetchUserEnvironment } from 'api/userEnvironment/apiFetchUserEnvironment';
import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { redirectRequireAuthentication } from 'modules/auth/routing/redirect-require-authentication';
import { orgDashboardApiIsomorphicFetchOrg } from 'modules/orgDashboard/api/orgDashboardApiFetchOrg';
import { orgDashboardRouteGroup } from 'modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteGroupLoaderArgs } from 'routing/classes/types/AppRouteGroupLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';
import type { HorizonAppRouteGroupShouldRevalidateFunctionArgs } from 'routing/types/HorizonAppRouteGroupShouldRevalidateFunctionArgs';

import { OrgDashboardOrgSubLayoutLoadable } from './OrgDashboardOrgSubLayoutLoadable';

export function shouldRevalidate({
  currentParams,
  nextParams,
}: HorizonAppRouteGroupShouldRevalidateFunctionArgs<
  typeof orgDashboardRouteGroup
>) {
  return currentParams.orgId !== nextParams.orgId;
}

export const handle = {
  searchFromPageType: 'DASHBOARD',
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { orgId },
}: HorizonAppRouteGroupLoaderArgs<typeof orgDashboardRouteGroup>) {
  const { user } = await apiIsomorphicFetchUserEnvironment({
    request,
    context,
  })();

  if (!user) return redirectRequireAuthentication({ request });

  const [{ org }] = await Promise.all([
    orgDashboardApiIsomorphicFetchOrg({ request, context })(orgId),
    OrgDashboardOrgSubLayoutLoadable.load(),
  ]);
  return { org };
}

export default function OrgDashboardOrgSubLayoutHorizonRoute({
  loaderData: { org },
}: HorizonAppRouteComponentProps<typeof loader>) {
  return <OrgDashboardOrgSubLayoutLoadable key={org.id} initialOrg={org} />;
}
